// src/Auth/Api.js
export const API_BASE_URL = "https://crmbackend.amplinova.com"; 
// export const API_BASE_URL = "http://localhost:8080"; // Local development URL